import { useState } from "react";
import { useNewsData } from "../../../lib/useMockData";
import ScrollReveal from "../../../components/feature/ScrollReveal";

export default function NewsList() {
  const { newsItems, categories } = useNewsData();
  const [activeCategory, setActiveCategory] = useState("all");

  const filtered =
    activeCategory === "all"
      ? newsItems
      : newsItems.filter((i) => i.type === activeCategory);

  return (
    <section className="py-16 md:py-24 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          {/* Category Filter */}
          <ScrollReveal direction="up">
            <div className="flex flex-wrap gap-2 mb-10">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.id)}
                  className={`px-4 py-2 text-xs font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer ${
                    activeCategory === cat.id
                      ? "bg-airdoa-navy text-white"
                      : "bg-airdoa-cream text-airdoa-gray hover:text-airdoa-navy"
                  }`}
                >
                  {cat.label}
                </button>
              ))}
            </div>
          </ScrollReveal>

          {/* News List */}
          <div className="flex flex-col gap-0">
            {filtered.map((item, idx) => (
              <ScrollReveal key={item.slug} direction="up" delay={idx * 60}>
                <div className="py-5 border-b border-airdoa-gray-light/50 group cursor-pointer">
                  <div className="flex items-center gap-3 mb-2">
                    <span
                      className={`px-2 py-0.5 text-[10px] font-medium rounded uppercase tracking-ultra ${
                        item.type === "column"
                          ? "bg-airdoa-cream text-airdoa-gold"
                          : item.type === "campaign"
                          ? "bg-red-50 text-red-500"
                          : "bg-airdoa-navy/10 text-airdoa-navy"
                      }`}
                    >
                      {item.category}
                    </span>
                    <span className="text-xs text-airdoa-gray">{item.date}</span>
                    {idx < 2 && (
                      <span className="ml-auto px-2 py-0.5 text-[10px] font-medium text-white bg-airdoa-gold rounded">
                        NEW
                      </span>
                    )}
                  </div>
                  <h3 className="text-sm md:text-base font-serif font-semibold text-airdoa-navy leading-relaxed group-hover:text-airdoa-gold transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-sm text-airdoa-gray leading-relaxed">
                    {item.excerpt}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>

          {filtered.length === 0 && (
            <div className="text-center py-12">
              <p className="text-sm text-airdoa-gray">—</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
